// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_CREATE_TOPIC = "Zalo\u017e f\u00f3rum";
export const GROUP_LIST = "Zoznam skup\u00edn";
export const LIST_OF_FORUMS = "Zoznam f\u00f3r";
export const SEO_DESCRIPTION_FORUM_category = "V\u0161etko o t\u00e9me %(category)s, \u010do mami\u010dky zauj\u00edma. Miesto pln\u00e9 sk\u00fasenost\u00ed, r\u00e1d, tipov a trikov priamo z prvej ruky.";
export const SEO_TITLE_FORUM_TOPICS = "V\u0161etko, \u010do mami\u010dky zauj\u00edma";
